const PROFILE_EVENTS = {
  PROFILE_START: 'PROFILE_START',
  PROFILE_SUCCESS: 'PROFILE_SUCCESS',
  PROFILE_FAILURE: 'PROFILE_FAILURE',
  PROFILE_POST_SUCCESS: 'PROFILE_POST_SUCCESS',
  PROFILE_POST_FAILURE: 'PROFILE_POST_FAILURE',
}

export default PROFILE_EVENTS
